import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  logsList: null,
  activeLog: {},
  fromDetailsPage: false,
  logs: null,
  error: false,
  loading: false,
  added: false,
  edited: false,
  logsLink:null,
  apiNotFound: false
};
const resetLogsState = (state, action) => {
  return updateObject(state, initialState)
}
const initLogsStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    apiNotFound: false
  });
};
const initLogLinkStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true
  });
};
const editLogStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};


const editLogSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    edited: true
  });
};

const editLogFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};
const addLogInit = (state, action) => {
  return updateObject(state, {
    added: false
  });
};

const addLogStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const addLogSuccess = (state, action) => {
  setLogs(state, action);

  return updateObject(state, {
    loading: false,
    added: true,

  });
};
const addLogFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};
const getOneLogStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const getOneLogFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};

const setLogs = (state, action) => {
  return updateObject(state, {
    loading: false,
    logsList: action.logsList,
    added: false,
    edited: false
  });
};

const setLogLink = (state, action) => {
  return updateObject(state, {
    loading: false,
    logsLink: action.logsLink,
    added: false,
    edited: false
  });
};
const setActiveLog = (state, action) => {
  return updateObject(state, {
    loading: false,
    activeLog: action.activeLog,
    added: false,
    edited: false,
    fromDetailsPage: false
  });
};
const setFromLogDetailsPage = (state, action) => {
  return updateObject(state, {
    fromDetailsPage: true
  });
};

const fetchLogsFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true,
    apiNotFound: true
  });
};
const fetchLogLinkFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_LOGS_START:
      return initLogLinkStart(state, action);
    case actionTypes.INIT_LOG_LINK_START:
      return initLogsStart(state, action);
    case actionTypes.GET_ONE_LOG_START:
      return getOneLogStart(state, action);
    case actionTypes.GET_ONE_LOG_FAIL:
      return getOneLogFail(state, action);
    case actionTypes.EDIT_LOGS_START:
      return editLogStart(state, action);
    case actionTypes.EDIT_LOGS_SUCCESS:
      return editLogSuccess(state, action)
    case actionTypes.EDIT_LOGS_FAIL:
      return editLogFail(state, action);
    case actionTypes.ADD_LOGS_INIT:
      return addLogInit(state, action);
    case actionTypes.ADD_LOGS_START:
      return addLogStart(state, action);
    case actionTypes.ADD_LOGS_SUCCESS:
      return addLogSuccess(state, action)
    case actionTypes.ADD_LOGS_FAIL:
      return addLogFail(state, action);
    case actionTypes.SET_LOGS:
      return setLogs(state, action);
    case actionTypes.SET_LOG_LINK:
      return setLogLink(state, action);
    case actionTypes.SET_ACTIVE_LOG:
      return setActiveLog(state, action);
    case actionTypes.SET_FROM_LOG_DETAILS_PAGE:
      return setFromLogDetailsPage(state, action);
    case actionTypes.FETCH_LOGS_FAILED:
      return fetchLogsFailed(state, action);
    case actionTypes.FETCH_LOG_LINK_FAILED:
      return fetchLogLinkFailed(state, action);
    default:
      return state;
  }
};

export default reducer;
